import * as types from '@/store/types'
export default {
    addEvent(context, payload) {
        context.events.push(payload)
    },
    eventDelete(context, eventId) {
        const index = context.events.findIndex(item => item.id === eventId)
        context.events.splice(index, 1)
    },
    eventAll(context, payload) {
        context.events = payload
    },
    setEvent: (context, payload) => {
        const index = context.events.findIndex(item => item.id === payload.id)
        context.events[index] = payload
    },
    changeBotIdModelDefault: (context, botId) => {
        context.modelDefault.bot_id = botId
    }
}
